import * as React from "react";
import { changePartiesLog} from '../actions/action';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Icon from '../../../icons';
import { getUserInfo } from '../../SpockViewPage/actions/action';
import ChangeLog from "./changeLog";
import CheckBox from "../../../components/Checkbox";

class PartyInfo extends React.Component {
    state = {
        showChaneLogInfo: false
    };

    handleChangeLog = (id) => {
        this.setState(
            { showChaneLogInfo: true },
            () => {
                const payload = {
                    party_id: id,
                };
                this.props.changePartiesLog(payload);
            }
        );
    };

    openMiniProfile = (targetRect, id) => {
        this.props.getUserInfo({
            target: targetRect,
            userId: id
        });
    };

    render() {
        // Safe fallback using an empty object to avoid TypeErrors
        let data = this.props.partyInfo || {};
        //Logic for if call trigger from admin
        if (this.props.isAdminPanel) {
            data = this.props.adminPartyInfo || {};
        }

        const { associatedParties } = this.props;

        if (
            this.state.showChaneLogInfo &&
            associatedParties?.changeLogData &&
            Object.keys(associatedParties.changeLogData).length > 0
        ) {
            return (
                <ChangeLog
                    openMiniProfile={this.openMiniProfile}
                    data={associatedParties.changeLogData}
                    onBackClick={() => this.setState({ showChaneLogInfo: false })}
                    onClose={this.props.onClose}
                />
            );
        }

        return (
            <div className="associatedParties scrollArea partyScroll">
                <header className="colFlex pdl__1 pdr__1 sticky">
                    <span className="alignMiddle">
                        {this.props.showBackButton && (
                            <a
                                href="javascript:void(0)"
                                className="backArrow mr"
                                onClick={this.props.onBackClick}
                            >
                                <Icon name="chev" className="icon shift__top__1 arrow" />
                            </a>
                        )}

                        <span className="flexGrow alignBase flexWrap">
                            <h2>Party Info</h2>
                        </span>

                        {(data.displayActions || this.props.showChangeLog) && (
                            <a
                                href="javascript:void(0)"
                                className="ml"
                                onClick={() => this.handleChangeLog(data.party_id)}
                            >
                                Change Log
                            </a>
                        )}

                        {data.can_edit_local_party && (
                            <a
                                className="ml__1"
                                href="javascript:void(0)"
                                onClick={() => this.props.editPartyFromInfo(data.party_id)}
                            >
                                Edit Party
                            </a>
                        )}

                        <a
                            className="h__16 ml__1"
                            href="javascript:void(0)"
                            onClick={this.props.onClose}
                        >
                            <Icon name="close" className="icon" />
                        </a>
                    </span>

                    {data.associated_date != null && (
                        <div className="infoTpa">
                            <span>Associated by</span>
                            {data.associated_by}
                            {!data.associated_by_is_active ? " (Inactive)" : ""}
                            <span> on </span>
                            {data.associated_date}
                        </div>
                    )}
                </header>

                <div className="partiesListDetail pdl__1 pdr__1 animated faster fadeInRight">
                    <ul className="rowFlex wrapFlex">
                        <li>
                            <label>Organization Name</label>
                            <span>{data.organization_name || '-'}</span>
                        </li>
                        <li>
                            <label>Legal Name</label>
                            <span>{data.legal_name || '-'}</span>
                        </li>
                        <li>
                            <label>Contact Name</label>
                            <span>{data.contact_name || '-'}</span>
                        </li>
                        <li>
                            <label>Party Type</label>
                            <span>{data.party_type || '-'}</span>
                        </li>
                        <li>
                            <label>Contact Relationship</label>
                            <span>{data.contact_relationship || '-'}</span>
                        </li>
                        <li>
                            <label>Entity Type</label>
                            <span>{data.party_entity_type || '-'}</span>
                        </li>
                        <li>
                            <label>Tax ID</label>
                            <span>{data.tax_id || '-'}</span>
                        </li>
                        <li>
                            <label>Account#</label>
                            <span>{data.account_number || '-'}</span>
                        </li>
                        <li>
                            <label>Carrier</label>
                            <span>{data.carrier_name || '-'}</span>
                        </li>
                        <li>
                            <label>Party Source</label>
                            <span>{data.party_source || '-'}</span>
                        </li>
                        <li>
                            <label>CPM ID</label>
                            <span>{data.cpm_id || '-'}</span>
                        </li>
                        {data.approved_for_payments && (
                            <li>
                                <label>Approved For Payments</label>
                                <span>{data.approved_for_payments || '-'}</span>
                            </li>
                        )}
                    </ul>

                    <div className="mt heading">Mailing Address</div>
                    <ul className="rowFlex wrapFlex">
                        <li>
                            <label>Mailing Address 1</label>
                            <span>{data.mailing_address1 || '-'}</span>
                        </li>
                        <li>
                            <label>Mailing Address 2</label>
                            <span>{data.mailing_address2 || '-'}</span>
                        </li>
                        <li>
                            <label>Mailing City</label>
                            <span>{data.mailing_city || '-'}</span>
                        </li>
                        <li>
                            <label>Mailing State</label>
                            <span>{data.mailing_state || '-'}</span>
                        </li>
                        <li>
                            <label>Mailing Zip</label>
                            <span>{data.mailing_zip || '-'}</span>
                        </li>
                        <li>
                            <label>Mailing Country</label>
                            <span>{data.mailing_country || '-'}</span>
                        </li>
                    </ul>

                    {data.billing_address_is_same && (
                        <div className="checkboxArea mb">
                            <CheckBox
                                disabled={true}
                                cssClass="alignMiddle"
                                item={{
                                    checked: data.billing_address_is_same,
                                    label: "Billing Address is same as the Mailing Address"
                                }}
                            />
                        </div>
                    )}

                    {!data.billing_address_is_same && (
                        <React.Fragment>
                            <div className="mt heading">Billing Address</div>
                            <ul className="rowFlex wrapFlex">
                                <li>
                                    <label>Billing Address 1</label>
                                    <span>{data.billing_address1 || '-'}</span>
                                </li>
                                <li>
                                    <label>Billing Address 2</label>
                                    <span>{data.billing_address2 || '-'}</span>
                                </li>
                                <li>
                                    <label>Billing City</label>
                                    <span>{data.billing_city || '-'}</span>
                                </li>
                                <li>
                                    <label>Billing State</label>
                                    <span>{data.billing_state || '-'}</span>
                                </li>
                                <li>
                                    <label>Billing Zip</label>
                                    <span>{data.billing_zip || '-'}</span>
                                </li>
                                <li>
                                    <label>Billing Country</label>
                                    <span>{data.billing_country || '-'}</span>
                                </li>
                            </ul>
                        </React.Fragment>
                    )}

                    <div className="mt heading">Phone Details</div>
                    {data?.phone_details?.length > 0 ? (
                        data.phone_details.map((item, idx) => (
                            <ul className="rowFlex wrapFlex" key={`pd-${idx}`}>
                                <li>
                                    <label>Phone Type {idx + 1}</label>
                                    <span>{item?.phone_type || '-'}</span>
                                </li>
                                <li>
                                    <label>Phone Number</label>
                                    <span>{item?.phone || '-'}</span>
                                </li>
                            </ul>
                        ))
                    ) : (
                        <ul className="rowFlex wrapFlex">
                            <li>
                                <label>Phone Type 1</label>
                                <span>-</span>
                            </li>
                            <li>
                                <label>Phone Number</label>
                                <span>-</span>
                            </li>
                        </ul>
                    )}

                    <div className="mt heading">Web &amp; Email Details</div>
                    <ul className="partiesInfoList rowFlex wrapFlex">
                        <li>
                            <label>Email</label>
                            <span>{data.email || '-'}</span>
                        </li>
                        <li>
                            <label>Website</label>
                            <span>{data.website || '-'}</span>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    associatedParties: state.header.associatedParties,
    partyInfo: state.header.associatedParties.partyInfo,
    userTimeZone: state.sessionContext.TimeZoneTz
});

const mapDispatchToProps = (dispatch) => ({
    changePartiesLog: bindActionCreators(changePartiesLog, dispatch),
    getUserInfo: bindActionCreators(getUserInfo, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartyInfo);